export const TUTORIALS = {
  welcome: {
    key: 'welcome',
    steps: [
      {
        title: '👋 Benvenuto in AgencyOS!',
        content:
          'Il tuo CRM per la gestione completa dell\'agenzia web. Gestirai clienti, preventivi, fatture, progetti e molto altro da un unico posto.',
        target: null,
      },
      {
        title: '🗂️ Navigazione principale',
        content:
          'Usa la barra laterale per spostarti tra le sezioni: Clienti, Preventivi, Fatturazione, Progetti, Scadenziario, Domini e altro.',
        target: '[data-testid="sidebar"]',
        position: 'right',
      },
      {
        title: '🔔 Notifiche',
        content:
          'Il campanello in alto a destra raccoglie tutte le notifiche attive: scadenze fatture, rinnovi domini e aggiornamenti sui progetti.',
        target: '[data-testid="notifications-btn"]',
        position: 'bottom',
      },
      {
        title: '✅ Pronto!',
        content:
          'Ogni sezione ha la sua guida che parte automaticamente la prima volta che la visiti. Puoi sempre riavviarla cliccando il pulsante ❓ in alto a destra.',
        target: null,
      },
    ],
  },

  '/': {
    key: '/',
    steps: [
      {
        title: '📊 Dashboard',
        content:
          'Panoramica completa dell\'agenzia: fatturato mensile, preventivi in attesa, progetti in corso e distribuzione dei servizi — tutto in un colpo d\'occhio.',
        target: null,
      },
      {
        title: '📈 KPI principali',
        content:
          'Le card in alto mostrano i dati più importanti: fatturato del mese, preventivi attivi, clienti totali e progetti in corso. Si aggiornano in tempo reale.',
        target: '[data-testid="kpi-cards"]',
        position: 'bottom',
      },
      {
        title: '💰 Grafico ricavi',
        content:
          'Il grafico a barre confronta le fatture emesse con quelle già incassate, mese per mese. Ottimo per monitorare la liquidità.',
        target: '[data-testid="revenue-chart"]',
        position: 'top',
      },
      {
        title: '🥧 Distribuzione servizi',
        content:
          'Il grafico a torta mostra quale mix di servizi stai vendendo di più. Utile per capire dove concentrare gli sforzi commerciali.',
        target: '[data-testid="services-chart"]',
        position: 'top',
      },
    ],
  },

  '/clienti': {
    key: '/clienti',
    steps: [
      {
        title: '👥 Clienti',
        content:
          'Anagrafica completa di tutti i tuoi clienti. Per ognuno registri: dati aziendali, contatti, Partita IVA, indirizzo e note libere.',
        target: null,
      },
      {
        title: '➕ Nuovo cliente',
        content:
          'Clicca "Nuovo Cliente" per aggiungere un\'anagrafica. Puoi creare un cliente rapido anche da altre sezioni (es. durante la creazione di un preventivo).',
        target: '[data-testid="add-client-btn"]',
        position: 'bottom',
      },
      {
        title: '📄 Contratti',
        content:
          'Per ogni cliente puoi allegare i contratti firmati in PDF o Word. I file vengono salvati in modo sicuro nel database.',
        target: null,
      },
    ],
  },

  '/preventivi': {
    key: '/preventivi',
    steps: [
      {
        title: '📋 Preventivi',
        content:
          'Crea e gestisci i preventivi per i tuoi clienti. Vengono numerati automaticamente nel formato PRV-ANNO-NUMERO (es. PRV-2026-0001).',
        target: null,
      },
      {
        title: '🔄 Ciclo di vita',
        content:
          'Ogni preventivo segue il flusso: Bozza → Inviato → Approvato / Rifiutato. Cambia lo stato direttamente dalla lista con un click.',
        target: null,
      },
      {
        title: '💼 Servizi inclusi',
        content:
          'Associa i servizi del tuo catalogo al preventivo. L\'importo totale viene calcolato automaticamente in base ai prezzi configurati.',
        target: null,
      },
    ],
  },

  '/fatturazione': {
    key: '/fatturazione',
    steps: [
      {
        title: '🧾 Fatturazione',
        content:
          'Gestisci tutte le fatture: acconti, saldi e fatture ricorrenti. Tieni traccia delle scadenze e dello stato di pagamento.',
        target: null,
      },
      {
        title: '🔁 Fatture ricorrenti',
        content:
          'Imposta fatture con ricorrenza mensile, trimestrale, semestrale o annuale — ideali per canoni di assistenza, hosting o SaaS.',
        target: null,
      },
      {
        title: '📊 Stato pagamento',
        content:
          'I possibili stati sono: Da Emettere, Emessa, Pagata, Scaduta. Aggiornali manualmente man mano che il cliente paga.',
        target: null,
      },
    ],
  },

  '/scadenziario': {
    key: '/scadenziario',
    steps: [
      {
        title: '📅 Scadenziario',
        content:
          'Il tuo calendario delle scadenze. Raccoglie in automatico le scadenze di fatture, rinnovi di domini e milestone di progetto.',
        target: null,
      },
      {
        title: '🔔 Promemoria anticipati',
        content:
          'Puoi impostare un promemoria N giorni prima della scadenza. Il sistema ti invierà una notifica in anticipo così non ti sfugge nulla.',
        target: null,
      },
      {
        title: '✅ Completare una scadenza',
        content:
          'Spunta la casella accanto a una scadenza per segnarla come completata. Le scadenze con ricorrenza si ripianificano automaticamente al ciclo successivo.',
        target: null,
      },
    ],
  },

  '/progetti': {
    key: '/progetti',
    steps: [
      {
        title: '🗂️ Progetti',
        content:
          'Gestisci tutti i progetti dell\'agenzia dalla pianificazione alla consegna. Ogni progetto è collegato a un cliente e ai servizi erogati.',
        target: null,
      },
      {
        title: '⏱️ Time tracking',
        content:
          'Registra le ore lavorate su ogni progetto. Il sistema calcola automaticamente il costo totale in base alla tariffa oraria del collaboratore.',
        target: null,
      },
      {
        title: '📊 Budget vs Costi',
        content:
          'Monitora il margine in tempo reale: budget concordato col cliente vs costi effettivi (ore × tariffa). Così sai sempre se stai guadagnando.',
        target: null,
      },
      {
        title: '🔄 Stato del progetto',
        content:
          'Il flusso è: Pianificato → In Corso → In Pausa → Completato. Puoi aggiornare lo stato in qualsiasi momento dalla lista o dal dettaglio.',
        target: null,
      },
    ],
  },

  '/domini': {
    key: '/domini',
    steps: [
      {
        title: '🌐 Domini',
        content:
          'Tieni traccia di tutti i domini gestiti per i tuoi clienti: registrar, DNS provider, date di scadenza e costi di rinnovo.',
        target: null,
      },
      {
        title: '⚠️ Alert di scadenza',
        content:
          'I domini vengono evidenziati 30 giorni prima della scadenza. Una voce viene creata automaticamente nello Scadenziario così non rischi di perderli.',
        target: null,
      },
      {
        title: '💰 Costi e ricavi',
        content:
          'Per ogni dominio registra il costo annuo di rinnovo e il ricavo che fatturi al cliente. Ottimo per calcolare il margine su questo servizio.',
        target: null,
      },
    ],
  },

  '/chat': {
    key: '/chat',
    steps: [
      {
        title: '💬 Chat interna',
        content:
          'Sistema di messaggistica per il team. Crea conversazioni legate a clienti o progetti specifici per tenere le comunicazioni sempre organizzate.',
        target: null,
      },
      {
        title: '🏷️ Tipi di messaggio',
        content:
          'Ogni messaggio può avere un tipo: Info, Domanda, Decisione, Urgente, Task. Utile per identificare rapidamente le comunicazioni più importanti.',
        target: null,
      },
      {
        title: '📌 Priorità e stati',
        content:
          'Le conversazioni hanno una priorità (bassa, normale, alta, urgente) e uno stato (Aperta, In Attesa, Risolta). Tieni il team sempre allineato.',
        target: null,
      },
    ],
  },

  '/calendario': {
    key: '/calendario',
    steps: [
      {
        title: '📅 Calendario',
        content:
          'Vista calendario con tutti gli eventi del team. Appuntamenti, telefonate e call in un\'unica schermata, sia personali che condivisi.',
        target: null,
      },
      {
        title: '🗓️ Creare un evento',
        content:
          'Clicca su un giorno per creare un nuovo evento. Scegli il tipo (Appuntamento, Telefonata, Call), la durata e se renderlo visibile a tutto il team.',
        target: null,
      },
    ],
  },

  '/servizi': {
    key: '/servizi',
    steps: [
      {
        title: '⚙️ Catalogo servizi',
        content:
          'Definisci i servizi che offre la tua agenzia: siti e-commerce, siti aziendali, SEO, ADS, grafica e altro. Vengono usati in preventivi e progetti.',
        target: null,
      },
      {
        title: '💵 Prezzi e tariffe',
        content:
          'Per ogni servizio imposta un prezzo base (per preventivi rapidi) e una tariffa oraria (per il calcolo dei costi nei progetti con time tracking).',
        target: null,
      },
    ],
  },

  '/report': {
    key: '/report',
    steps: [
      {
        title: '📊 Report e analisi',
        content:
          'Analisi dettagliate delle performance dell\'agenzia: andamento ricavi, distribuzione dei servizi, stato dei progetti e molto altro.',
        target: null,
      },
      {
        title: '📈 Confronto ricavi',
        content:
          'Confronta i ricavi mese per mese, filtra per periodo e identifica quali servizi generano più fatturato. Dati sempre aggiornati in tempo reale.',
        target: null,
      },
    ],
  },

  '/impostazioni': {
    key: '/impostazioni',
    steps: [
      {
        title: '⚙️ Impostazioni',
        content:
          'Configura AgencyOS secondo le tue esigenze: dati dell\'agenzia, gestione del team, tariffe orarie e configurazione email SMTP.',
        target: null,
      },
      {
        title: '👥 Gestione team',
        content:
          'Aggiungi collaboratori al sistema. I collaboratori accedono al CRM con permessi limitati rispetto all\'amministratore.',
        target: null,
      },
      {
        title: '📧 Email SMTP',
        content:
          'Configura le credenziali SMTP per inviare email dal CRM (reset password, notifiche automatiche ai clienti). Obbligatorio per il recupero password.',
        target: null,
      },
    ],
  },
};
